import React from 'react';
import { BaseMenu, BaseMenuProps } from './BaseMenu';

export type MenuProps = Omit<
  BaseMenuProps,
  'type' | 'onMouseLeave' | 'onMouseEnter'
>;

export const Menu: React.FC<MenuProps> = (props) => (
  <BaseMenu {...props} type="root" />
);

Menu.displayName = 'Menu';
